import { Flex, Form, Switch } from "antd";
import * as React from "react";
import { ZodBoolean } from "zod";

import { FieldDef, itemName, makeLabel } from "../attrMetaEditorUtils";

type PropsBoolEd = {
  node: ZodBoolean;
  path: string[];
  field?: FieldDef;
};

/**
 * Булевское свойство атрибута, н.р. required
 */
export const BoolEd: React.FC<PropsBoolEd> = (props) => {
  const { node, path, field } = props;
  return (
    <Flex gap={8} align="center">
      <Form.Item name={itemName(path)} noStyle>
        <Switch
          checkedChildren="true"
          unCheckedChildren="false"
          title={path.join(".")}
        />
      </Form.Item>
      {makeLabel(node, path, field)}
    </Flex>
  );
};
